import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Modal, Input } from 'antd';

import requestAPI from '../../../helpers/requestAPI';
import { setChangedBrowserDataWhenAdd } from '../../../actions';
import { toastSuccess, toastError } from '../../../utils/toastr';

const FolderModalForm = ({ visible, changeVisible, site_id, directory, filesTree, setChangedBrowserDataWhenAdd }) => {
	const [ nameFolder, setNameFolder ] = useState('');

	const sendData = () => {
		const params = {
			routeParams: {
				route: 'dir'
			},
			method: 'POST',
			data: {
				site_id: site_id,
				directory: directory,
				name: nameFolder
			}
		};
		const value = {
			name: nameFolder,
			siteName: JSON.parse(filesTree[0].value).siteName,
			siteId: site_id,
			isFolder: true,
			directory: directory ? directory : '/'
		};
		const addedDirectory = {
			value: JSON.stringify(value),
			label: nameFolder,
			showCheckbox: false,
			children: [ { value: 'waiting server response...', label: 'waiting server response...', showCheckbox: false } ]
		};

		requestAPI(params)
			.then((response) => {
				if (response.data.ms === 'Ошибка') {
					toastError(response.data.error);
				} else {
					setChangedBrowserDataWhenAdd(addedDirectory);
					toastSuccess('Directory was created.', 'OK');
				}
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const handleSubmit = () => {
		sendData();
		setNameFolder('');
		changeVisible();
	};

	return (
		<Modal title="Create folder" visible={visible} onCancel={changeVisible} onOk={handleSubmit}>
			<Input placeholder="Enter folder name" value={nameFolder} onChange={(e) => setNameFolder(e.target.value)} />
		</Modal>
	);
};

const mapStateToProps = (state) => {
	return {
		site_id: state.selectedElement.siteId,
		directory: state.selectedElement.directory,
		filesTree: state.files.browserData
	};
};

const mapDispatchToProps = (dispatch) => ({
	setChangedBrowserDataWhenAdd: (data) => dispatch(setChangedBrowserDataWhenAdd(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(FolderModalForm);
